import { render, staticRenderFns } from "./Snot20Block.vue?vue&type=template&id=0898641d&lang=pug&"
import script from "./Snot20Block.vue?vue&type=script&lang=js&"
export * from "./Snot20Block.vue?vue&type=script&lang=js&"
import style0 from "./Snot20Block.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports